<template>
<div>

    <wewHeader></wewHeader>
  

    <section class="select-date-time">
        <div class="container pad-b-80">
            <div v-if="appointmentStatus==4" class="text-center">
                <h1 class="text-center pad-t-60 pad-b-30">BOOK YOUR APPOINTMENT</h1>
                <h2>Select your preferred date and time below</h2>
            </div>
            <div v-else>
                <h1 class="text-center pad-t-60 pad-b-30">MY APPOINTMENT</h1>
            </div>

            <!-- form -->
            <div v-if="!actioned && !offerHasExpired && ( appointmentStatus==2 || appointmentStatus==4 || appointmentStatus==6 )">

                <!-- pickers -->
                <div class="w-grid trim gutters-2x">
                    
                    <div class="w-1 w-sm-1-2 marg-tb-20">
                        <v-date-picker class="inline"
                        v-model="appointDate"
                        :first-day-of-week="1"
                        :title-date-format="formatNiceDate"
                        :min="offerFrom" 
                        :max="offerExpiry"
                        :allowed-dates="allowedDays"
                        full-width
                        :reactive="true"></v-date-picker>
                    </div>
                    <div class="w-1 w-sm-1-2 marg-tb-20">
                        <h2 class="timeslots-title pad-lr-15 bg-blue color-white"><span :style="[ appointTime ? {'opacity' :'.6'} : {'opacity' :'1'} ]">Your appointment time</span><span class="time-title block">{{ appointTime }}</span></h2>
                        <div class="timeslots w-grid trim gutters-2x pad-t-20">
                            <div class="w-1 w-sm-1-2 text-center" 
                                v-for="(step,index) in timeslots" 
                                v-bind:key="index">
                                <button :class="[ appointTime==timeslots[index] ? 'color-white bg-blue' : 'color-black bg-white', 'btn-timeslot pad-tb-15 marg-b-10 iblock' ]"
                                        @click.prevent="selectTimeslot(index)"
                                        type="button">
                                        {{ timeslots[index] }}</button>
                            </div>
                        </div>
                        <!-- <v-time-picker class="inline" 
                        v-model="appointTime"
                        min="10:00" 
                        max="17:00"
                        :allowed-minutes="allowedStep"
                        full-width></v-time-picker> -->
                    </div>
                    
                </div>
                <!-- pickers -->
                <!-- buttons -->
                <div v-if="!actioned" class="text-center pad-t-20">
                    <button v-if="appointmentStatus==4" :disabled="!appointDate || !appointTime" type="button" class="m4c-btn color-white marg-t-10 marg-lr-10" @click="bookAppointment">BOOK</button>
                    <button v-if="appointmentStatus==2 || appointmentStatus==6" :disabled="!appointDate || !appointTime" type="button" class="m4c-btn color-white marg-t-10 marg-lr-10" @click="rescheduleAppointment">RESCHEDULE</button>
                    <button v-if="appointmentStatus==2 || appointmentStatus==6" :disabled="!appointDate || !appointTime" type="button" class="m4c-btn charcoal color-white marg-t-10 marg-lr-10" @click="cancelAppointment">CANCEL</button>
                </div>
                <!-- buttons -->


                <!-- <div>Appointment Status: {{ appointmentStatus }}</div>
                <div>Appointment Expiry: {{ offerExpiry }}</div> -->
            </div><!-- /form -->

            <div v-if="actioned">
                <h2 class="msg text-center marg-b-80" v-html="actionMsg"></h2>
            </div>

            <div v-if="appointmentStatus==3 || (appointmentStatus==6 && offerHasExpired )">
                <h2 class="msg text-center marg-b-80">Sorry but your offer has now expired<br>
                If you wish to submit your car again<br>please go to our home page <a href="./"><span class="color-blue">HERE</span></a>
                </h2>
            </div>

            <div v-if="appointmentStatus==5">
                <h2 class="msg text-center marg-b-80">Your appointment was cancelled<br>Please re-submit your car for another offer</h2>
            </div>

        </div>
    </section>

    <wewFooterWhite></wewFooterWhite>

</div>
</template>

<script>
import wewHeader from '@/components/Header'
import wewFooterWhite from '@/components/wew-footer-white'
import moment from 'moment'

import 'vuetify/dist/vuetify.min.css';
export default {
    name: 'appointment',
    components: {
        wewHeader, 
        wewFooterWhite 
    },
    props: {
        query: null
    },
    data() {
        return { 
            actioned: false,
            actionMsg: '',
            timeslots: [
                '10:00',
                '10:30',
                '11:00',
                '11:30',
                '12:00',
                '12:30',
                '13:00',
                '13:30',
                '14:00',
                '14:30',
                '15:00',
                '15:30',
                '16:00',
                '16:30',
                '17:00'
            ]
            //offerFrom: '2019-04-04',
            //offerExpiry: '2019-04-11'
        }
    },
    beforeMount () {
        if(!this.query) {
                this.$router.push({name: 'home'})
        }
    },
    mounted() {
        if( this.appointmentStatus==1 ||
            this.appointmentStatus==7 ||
            this.appointmentStatus==8 
        ) {
            this.$router.push({name: 'home'})
        }
    },
    computed: {
        submission() {
            return this.$store.getters.submission
        },
        appointment() {
            return this.$store.getters.appointment
        },     
        appointmentStatus() {
            return this.$store.getters.appointmentStatus
        },   
        offerExpiry() {
            return this.$store.getters.offerExpiry
        },
        offerHasExpired() {
            // not now necessary, just use appointmentStatus==3
            let today = moment().format('YYYY-MM-DD')
            let expires = this.offerExpiry
            return today > expires
        },
        appointDate: {
            get: function() {
                return this.appointment !== null ? this.appointment.date : null
            },
            set: function(newValue) {
                this.$store.dispatch('setAppointmentDate', newValue)
            }
        },
        appointTime: {
            get: function() {
                return this.appointment !== null ? this.appointment.time : null
            },
            set: function(newValue) {
                this.$store.dispatch('setAppointmentTime', newValue)
            }
        },
        // offerExpiry() {
        //     return this.offerExpiry !== null ? this.offerExpiry : null
        // },
        offerFrom() {
            let tomorrow = moment().add(1, 'day').endOf('day')
            return moment(tomorrow).format('YYYY-MM-DD')
        },
        
    },
    methods: {
        selectTimeslot(index) {
            this.appointTime = this.timeslots[index]
        },
        allowedStep: m => {
          return m%30===0;
        },
        allowedDays: val => {
          return moment(val).day()!==0 && moment(val).day()!==6;
        }, // exclude Saturdays and Sundays
        formatNiceDate: d => { 
            //let exp = d.split("-");
            //return exp[2]+' '+exp[1]+' '+exp[0];
            return moment(d).format('dddd, Do MMMM')
        },
        bookAppointment() {
            this.$store.dispatch('bookAppointment')
            this.actioned = true
            this.actionMsg = 'Great, your appointment has been booked. See you soon!'
            window.scrollTo(0,0);
        },
        rescheduleAppointment() {
            this.$store.dispatch('rescheduleAppointment')
            this.actioned = true
            this.actionMsg = 'Thanks, your appointment has now been rescheduled'
            window.scrollTo(0,0);
        },
        cancelAppointment() {
            this.$store.dispatch('cancelAppointment')
            this.actioned = true
            this.actionMsg = "Your appointment has now been cancelled<br>We're sorry you can't make it and welcome you to try again soon"
            window.scrollTo(0,0);
        },

    },
    created() {
        this.$store.dispatch('fetchAppointment', this.query)
        this.$store.dispatch('fetchSubmission', this.query)
    }
}
</script>

<style>
.v-picker__title{
    background-color: #008EC8;
    color: #FFFFFF;
}

.v-picker--date .v-picker__title{
    padding-bottom: 22px;
    padding-top: 24px;
}

.v-picker--date .v-picker__body{
    padding-bottom: 4px;
}

.v-date-picker-table--date .v-btn.v-btn--active{
    background-color: #008EC8;
}

.v-date-picker-table--date button.v-btn{
    font-weight:bold;
    font-size: 16px;
}

.v-date-picker-table--date td{
    padding: 5px 0;
}
.v-time-picker-clock__item--active{
    background-color: #008EC8;
}

.v-time-picker-clock__hand{
    background-color: #008EC8;
}

.v-time-picker-clock__item{
    font-weight: bold;
}

.v-time-picker-title__ampm{
    font-size:28px;
}

.timeslots-title{
    height: 102px;
    font-size: 16px;
    font-weight: 500;
    padding-top:25px;
}


.timeslots{
    height: 290px;
    max-height: 290px;
    overflow: hidden;
    overflow-y: scroll;
}

.timeslots::-webkit-scrollbar {
width: 0px; /* remove scrollbar space */
background: transparent;
}

.time-title{
    margin-top: 8px;
    font-size: 34px;
    font-weight: 500;
}

button.btn-timeslot{
    text-align: center;
    font-weight: bold;
    border: 2px solid #666;
    border-radius: 3px;
    width:100%;
}

button.btn-timeslot.bg-white:hover{
    background: #e5e5e5;
}

button.btn-timeslot.bg-blue,
button.btn-timeslot.bg-blue:hover{
    border: 2px solid #008EC8;
}

h2.msg{
    font-size: 24px;
    line-height: 28px;
}
</style>
